// File: frontend/src/components/ui/AppButton.js
//
// The one button in the design system. Instead of every screen choosing a MUI
// `variant`/`color` (which produced 134 outlined vs 95 contained buttons and no
// clear primary action), callers pick an INTENT that encodes meaning:
//
//   primary   → the single, obvious main action on a view (contained brand)
//   secondary → supporting action (outlined)
//   danger    → destructive/irreversible action (contained error)
//   ghost     → low-emphasis / tertiary (text)
//
// Rule of thumb: exactly ONE `primary` per view. All styling is inherited from
// the theme, so AppButton looks identical to today's buttons — it just gives the
// team a semantic, consistent API to standardise on.

import React from "react";
import { Button } from "@mui/material";

const INTENT = {
  primary:   { variant: "contained", color: "primary" },
  secondary: { variant: "outlined",  color: "primary" },
  danger:    { variant: "contained", color: "error" },
  ghost:     { variant: "text",      color: "primary" },
};

export default function AppButton({ intent = "primary", children, ...props }) {
  const cfg = INTENT[intent] || INTENT.primary;
  return (
    <Button variant={cfg.variant} color={cfg.color} {...props}>
      {children}
    </Button>
  );
}
